import * as AC from './actionTypes';

export const getBuildings = (filters = {}) => ({
  type: AC.GET_BUILDINGS_REQUEST,
  filters,
});

export const getAllBuildings = (filters = {}) => ({
  type: AC.GET_ALL_BUILDINGS_REQUEST,
  filters,
});

export const getBuildingById = id => ({
  type: AC.GET_BUILDING_DETAILS_REQUEST,
  id,
});

export const addBuilding = (name, city, country, address) => ({
  type: AC.ADD_BUILDING_REQUEST,
  payload: {
    name,
    city,
    country,
    address,
  },
});

export const editBuilding = (name, city, country, address, id) => ({
  type: AC.EDIT_BUILDING_REQUEST,
  payload: {
    name,
    city,
    country,
    address,
    id,
  },
});

export const deleteBuilding = id => ({
  type: AC.DELETE_BUILDING_REQUEST,
  id,
});

export const getBuildingsGraph = () => ({
  type: AC.GET_BUILDINGS_GRAPH_REQUEST,
});
